import Currency from './Currency';

class Price {
    value: number;

    currency: Currency;
}

function priceFilter(price: Price, language = 'de-DE'): string {
    let options;
    if (price.value > 1000) {
        options = { maximumFractionDigits: 0 };
    } else {
        options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    }
    const value = Intl.NumberFormat(language, options).format(price.value);

    return `${price.currency.symbol} ${value}`;
}

export default priceFilter;
